import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Loading from "../../../../Extra/Loading";

import {
  getCurrentDate,
  minutesToHHMM,
  getCurrentMonthFirstDate,
  secondsToTime,
} from "../../../../Utilitie";

import DownloadExcel from "../../../../Extra/DownloadExcel";
import AdrmDailyBlockPositionGraph from "./AdrmDailyBlockPositionGraph";
import AdrmGraphMaster from "./Graph/AdrmGraphMaster";

const ADRMDailyBlockPositionReport = () => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [rawData, setRawData] = useState([]);
  const tableRef = useRef();
  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());
  const [totalRow, setTotalRow] = useState();
  const [fetchBtnClick, setFetchBtnClick] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setTotalRow(rawData.length / 3);
  }, [rawData]);

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getBlockDataAdrmDaily?fromDt=${startDate}&toDt=${endDate}`
      );

      if (response.data.status === "ok") {
        setRawData(response.data.data);
      } else {
        setRawData([]);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchedData();
  }, []);

  const prepareTableData = () => {
    const engg = rawData.filter((item) => item.dept === "Engg");
    const trd = rawData.filter((item) => item.dept === "TRD");
    const snt = rawData.filter((item) => item.dept === "S&T");

    const rows = [];

    // Loop until the longest array finishes (using any array's length check)
    for (let i = 0; engg[i] || trd[i] || snt[i]; i++) {
      rows.push({
        engg: engg[i] || {},
        trd: trd[i] || {},
        snt: snt[i] || {},
      });
    }
    return rows;
  };
  const handleFetch = () => {
    fetchedData();
    setFetchBtnClick(!fetchBtnClick);
  };
  ////////////

  return (
    <div>
      <AdrmGraphMaster dates={{ startDate, endDate }} />
      <div className="d-flex justify-content-between bg-dark text-white p-1 papaDiv">
        <h5 className="">ADRM Daily Block Position Report </h5>

        <div>
          <div className="d-flex  align-items-center ">
            <b>From </b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="me-1"
            />

            <b>To </b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <button
              className="ms-1 btn btn-sm btn-outline-light"
              onClick={handleFetch}
            >
              Fetch
            </button>
          </div>
        </div>
      </div>
      <AdrmDailyBlockPositionGraph
        fetchBtnClick={fetchBtnClick}
        dates={{ startDate, endDate }}
      />

      <div className="table-responsive position-relative">
        <table
          ref={tableRef}
          className="table table-bordered table-striped mb-4 papaDiv"
          style={{ fontSize: "12px" }}
        >
          <thead>
            <tr className="table-dark text-center">
              <th rowSpan={2} className="align-middle ">
                Sr No.
              </th>
              <th rowSpan={2} className="align-middle ">
                Block Date
              </th>

              <th colSpan={6}>Engg</th>
              <th colSpan={6}>TRD</th>
              <th colSpan={6}>S&T</th>
            </tr>
            <tr className="table-secondary text-center table-dark">
              <th>Blocks Agreed</th>
              <th>Hours Agreed</th>
              <th>Blocks Granted</th>
              <th>Hours Granted</th>
              <th>Comp Block %</th>
              <th>Hours Block %</th>
              <th>Blocks Agreed</th>
              <th>Hours Agreed</th>
              <th>Blocks Granted</th>
              <th>Hours Granted</th>
              <th>Comp Block %</th>
              <th>Hours Block %</th>
              <th>Blocks Agreed</th>
              <th>Hours Agreed</th>
              <th>Blocks Granted</th>
              <th>Hours Granted</th>
              <th>Comp Block %</th>
              <th>Hours Block %</th>
            </tr>
          </thead>
          <tbody>
            {prepareTableData().map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                {/* ////// */}
                <td>
                  {row.engg.block_date?.slice(0, 10) ||
                    row.snt.block_date?.slice(0, 10) ||
                    row.trd.block_date?.slice(0, 10) ||
                    "-"}
                </td>
                <td>{row.engg.total_corridor_blocks_agreed || "-"}</td>
                <td>
                  {secondsToTime(row.engg.total_corridor_hours_agreed).replace(
                    "NaN:NaN",
                    "-"
                  ) || "-"}
                </td>
                <td>{row.engg.total_corridor_blocks_granted || "-"}</td>
                <td>
                  {secondsToTime(row.engg.total_corridor_hours_granted).replace(
                    "NaN:NaN",
                    "-"
                  ) || "-"}
                </td>{" "}
                <td>{row.engg.percent_comp_block || "-"}</td>
                <td>{row.engg.percent_hours_block || "-"}</td>
                {/* /////////////*/}
                <td>{row.trd.total_corridor_blocks_agreed || "-"}</td>
                <td>
                  {secondsToTime(row.trd.total_corridor_hours_agreed).replace(
                    "NaN:NaN",
                    "-"
                  ) || "-"}
                </td>
                <td>{row.trd.total_corridor_blocks_granted || "-"}</td>
                <td>
                  {secondsToTime(row.trd.total_corridor_hours_granted).replace(
                    "NaN:NaN",
                    "-"
                  ) || "-"}
                </td>{" "}
                <td>{row.trd.percent_comp_block || "-"}</td>
                <td>{row.trd.percent_hours_block || "-"}</td>
                {/* /////////////// */}
                <td>{row.snt.total_corridor_blocks_agreed || "-"}</td>
                <td>
                  {secondsToTime(row.snt.total_corridor_hours_agreed).replace(
                    "NaN:NaN",
                    "-"
                  ) || "-"}
                </td>
                <td>{row.snt.total_corridor_blocks_granted || "-"}</td>
                <td>
                  {secondsToTime(row.snt.total_corridor_hours_granted).replace(
                    "NaN:NaN",
                    "-"
                  ) || "-"}
                </td>{" "}
                <td>{row.snt.percent_comp_block || "-"}</td>
                <td>{row.snt.percent_hours_block || "-"}</td>
              </tr>
            ))}
            {/* ///// */}
            <tr className="table-dark fw-bold">
              <td colSpan={2} className="text-center">
                Total
              </td>
              {["Engg", "TRD", "S&T"].map((dept) => {
                const filtered = rawData.filter((item) => item.dept === dept);
                const totals = {
                  total_corridor_blocks_agreed: 0,
                  total_corridor_hours_agreed: 0,
                  total_corridor_blocks_granted: 0,
                  total_corridor_hours_granted: 0,
                };

                filtered.forEach((item) => {
                  totals.total_corridor_blocks_agreed += Number(
                    item.total_corridor_blocks_agreed || 0
                  );
                  totals.total_corridor_hours_agreed += Number(
                    item.total_corridor_hours_agreed || 0
                  );
                  totals.total_corridor_blocks_granted += Number(
                    item.total_corridor_blocks_granted || 0
                  );
                  totals.total_corridor_hours_granted += Number(
                    item.total_corridor_hours_granted || 0
                  );
                });

                return (
                  <React.Fragment key={dept}>
                    <td>{totals.total_corridor_blocks_agreed}</td>
                    <td>{secondsToTime(totals.total_corridor_hours_agreed)}</td>
                    <td>{totals.total_corridor_blocks_granted}</td>
                    <td>
                      {secondsToTime(totals.total_corridor_hours_granted)}
                    </td>
                    <td>
                      {(
                        (totals.total_corridor_blocks_granted * 100) /
                        totals.total_corridor_blocks_agreed
                      ).toFixed(2)}
                    </td>

                    <td>
                      {(
                        (totals.total_corridor_hours_granted * 100) /
                        totals.total_corridor_hours_agreed
                      ).toFixed(2)}
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>{" "}
            <tr className="table-dark fw-bold">
              <td colSpan={2} className="text-center">
                Avarage
              </td>
              {["Engg", "TRD", "S&T"].map((dept) => {
                const filtered = rawData.filter((item) => item.dept === dept);
                const totals = {
                  total_corridor_blocks_agreed: 0,
                  total_corridor_hours_agreed: 0,
                  total_corridor_blocks_granted: 0,
                  total_corridor_hours_granted: 0,
                };

                filtered.forEach((item) => {
                  totals.total_corridor_blocks_agreed += Number(
                    item.total_corridor_blocks_agreed / totalRow || 0
                  );
                  totals.total_corridor_hours_agreed += Number(
                    item.total_corridor_hours_agreed / totalRow || 0
                  );
                  totals.total_corridor_blocks_granted += Number(
                    item.total_corridor_blocks_granted / totalRow || 0
                  );
                  totals.total_corridor_hours_granted += Number(
                    item.total_corridor_hours_granted / totalRow || 0
                  );
                });

                return (
                  <React.Fragment key={dept}>
                    <td>{totals.total_corridor_blocks_agreed.toFixed(2)}</td>
                    <td>{secondsToTime(totals.total_corridor_hours_agreed)}</td>
                    <td>{totals.total_corridor_blocks_granted.toFixed(2)}</td>
                    <td>
                      {secondsToTime(totals.total_corridor_hours_granted)}
                    </td>
                    <td>
                      {(
                        (totals.total_corridor_blocks_granted * 100) /
                        totals.total_corridor_blocks_agreed
                      ).toFixed(2)}
                    </td>
                    <td>
                      {" "}
                      {(
                        (totals.total_corridor_hours_granted * 100) /
                        totals.total_corridor_hours_agreed
                      ).toFixed(2)}
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>{" "}
          </tbody>
        </table>

        {loading && <Loading />}
      </div>
      <div className="m-1">
        {!rawData ? (
          <b style={{ color: "red", fontSize: "14px" }}>Data not found!</b>
        ) : null}
        <DownloadExcel
          tableRef={tableRef}
          fileName={`ADRM Daily Block Position Report - ${startDate}-${endDate}`}
        />
      </div>
    </div>
  );
};

export default ADRMDailyBlockPositionReport;
